import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import { Box, Stack, Typography } from "@mui/material";

import Page from "./Page";

import useSyndication from "../../hooks/useSyndication";
import useLocalization from "../../hooks/useLocalization";
import useBrowser from "../../hooks/useBrowser";

import Card from "../layout/Card";
import Territories from "../ui/Territories";
import Loading from "../ui/Loading";
import ClientProjectItem from "../ui/ClientProjectItem";

import WeeklyCalls from "../ui/WeeklyCalls";

const Syndication = () => {
  const { syndication, getSyndicatedProjects, syndicatedProjects } =
    useSyndication();

  const { getTitle, getMessage } = useLocalization();
  const { windowHeight, windowWidth } = useBrowser();

  const location = useLocation();
  const navigate = useNavigate();

  const [refresh, setRefresh] = useState(0);

  let years = [
    { id: new Date().getFullYear(), name: new Date().getFullYear() },
    { id: new Date().getFullYear() + 1, name: new Date().getFullYear() + 1 },
  ];

  useEffect(() => {
    if (!syndication) return;

    getSyndicatedProjects();
  }, [syndication]);

  const handleTerritoryUpdate = () => {
    setRefresh((current) => {
      return current + 1;
    });
  };

  const handleToolbarClick = (action) => {
    switch (action) {
      case "importexport":
        navigate("/syndicationimportexport", {
          state: {
            syndicationId: syndication.id,
            name: syndication.name,
          },
        });
        break;
    }
  };

  const handleProjectClick = (project) => {
    navigate(`/project`, {
      state: {
        projectId: project.id,
        clientId: project.clientId,
        backDestination: "/syndication",
      },
    });
  };

  if (!syndication) return <Loading />;

  return (
    <>
      <Page
        pageName={syndication?.name}
        includeToolbar
        items={[{ name: "importexport", iconName: "ImportExport" }]}
        onToolItemClick={handleToolbarClick}
      >
        <Box
          sx={{ display: "flex" }}
          gap={2}
        >
          <Card
            title={getTitle("syndicatedProjects")}
            sx={{ width: "300px", height: `${windowHeight - 140}px` }}
          >
            {syndicatedProjects === null ? (
              <Loading />
            ) : Array.isArray(syndicatedProjects) &&
              syndicatedProjects.length > 0 ? (
              <Stack
                sx={{ padding: "8px" }}
                spacing={1}
              >
                {syndicatedProjects.map((project) => (
                  <ClientProjectItem
                    key={project.id}
                    project={project}
                    onClick={handleProjectClick}
                  />
                ))}
              </Stack>
            ) : (
              <Typography>{getMessage("noProjects")}</Typography>
            )}
          </Card>

          <Card
            title={getTitle("territories")}
            sx={{ width: "300px", height: `${windowHeight - 140}px` }}
          >
            <Territories
              syndicationId={syndication.id}
              users={[]}
              onSave={handleTerritoryUpdate}
              refresh={refresh}
              height={windowHeight - 140}
            />
          </Card>

          <Card
            title={getTitle("Schedule")}
            sx={{ width: `${windowWidth - 600}px` }}
          >
            <Box
              sx={{
                padding: "10px",
              }}
            >
              <WeeklyCalls
                syndicationId={syndication?.id}
                refreshData={refresh}
              />
            </Box>
          </Card>
        </Box>
      </Page>
    </>
  );
};

export default Syndication;
